<template>
  <modal
    :is-visible="isVisible"
    title="Share"
    @close="close"
  >
    <form-wrap>
      <form-field-set :should-show-border="false">
        <select-input
          v-model="selectedEmail"
          :label="$t('c.contentShareModal.form.label.recepient')"
          :options="selectOptions"
          name="recepient-email-select"
          direction="vertical"
          empty-label="Email Adresse"
        />
        <text-input
          v-model="email"
          name="randomTextArea"
          direction="vertical"
        />
        <tags-input
          v-model="tags"
          :label="$t('c.contentShareModal.form.label.tags')"
          :options="tagsOptions"
          name="tags"
          direction="vertical"
        />

      </form-field-set>

      <form-actions>
        <button-input>
          <font-awesome-icon
            icon="arrow-alt-circle-right"
          />
          <span v-t="'c.contentShareModal.form.action.submit'"/>
        </button-input>
        <a
          v-t="'c.contentShareModal.form.action.cancel'"
          class="cancel"
          @click="close()"
        />
      </form-actions>
    </form-wrap>
  </modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import FormMixin from '@/mixins/forms/Form'
import Modal from '@/components/ui/Modal'

export default {
  name: 'ContentShareModal',
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon,
    Modal
  },
  data () {
    return {
      selectedEmail: '',
      email: 'anne.andresen@deutschebahn.de',
      tags: []
    }
  },
  computed: {
    isVisible () {
      return this.$store.state.contentShareModal.isVisible
    },
    selectOptions () {
      return [
        { label: 'John Doe', value: 'john@doe.com' },
        { label: 'Johanna Maier', value: 'johanna@maier.de' }
      ]
    },
    tagsOptions () {
      return [
        { label: 'Innovation', value: 'Innovation' },
        { label: 'Transportation', value: 'Transportation' }
      ]
    }
  },
  methods: {
    ...mapActions({
      show: 'openContentShareModal',
      close: 'closeContentShareModal',
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contents/ContentShareModal.vue